import { defineRoutes } from '#utils';

export const routes = defineRoutes({
  dashboard: {
    users: {
      find: '/admin/dashboard/users',
    },
  },
});
